import React, { useContext, useEffect, useRef, useState } from "react";
import SingleItem from "./SingleItem";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../../../../Contexts/AuthContext/AuthProvider";
import CustomPaginationMobile from "../../../../CustomPagination/CustomPaginationMobile";
import Loader from "../../../../Loader/Loader";
import MobileBitcoinMiningHistory from "./MobileBitcoinMiningHistory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectOption from "./SelectOption/SelectOption";
import "./BitCoinMining.css";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
const MobileBitcoinMining = () => {
  const { authUser } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState([]);
  const [paginateData, setPaginateData] = useState([]);
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   fetch(`https://api.wlffinance.org/api/user/mining/bitcoin/view`, {
  //     method: "GET",
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setData(data?.data);
  //       setPaginateData(data);
  //       setLoading(false);
  //     });
  // }, []);

  // const handlePage = (event) => {
  //   try {
  //     const pageNumber = event?.selected + 1;
  //     const config = {
  //       headers: {
  //         "content-type": "application/json",
  //       },
  //     };
  //     axios
  //       .get(
  //         `https://api.wlffinance.org/api/user/mining/bitcoin/view?page=${pageNumber}`,
  //         config
  //       )
  //       .then((response) => {
  //         setData(response?.data?.data);
  //         setPaginateData(response?.data);
  //       })
  //       .catch((error) => {});
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    fetch(`https://api.wlffinance.org/api/user/mining/bitcoin/filter/view`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data?.data);
        setPaginateData(data);
        setTotalData(data?.totalData);
        setLoading(false);
      });
  }, []);

  const [filter, setFilter] = useState("");

  const handlePage = (event) => {
    try {
      if (event?.target?.value) {
        setFilter(event?.target?.value);
      }
      const pageNumber = event?.selected + 1;
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      if (event?.target?.value) {
        axios
          .get(
            `https://api.wlffinance.org/api/user/mining/bitcoin/filter/view?page=1&filter=${event?.target?.value}`,
            config
          )
          .then((response) => {
            setData(response?.data?.data);
            setPaginateData(response?.data);
          })
          .catch((error) => {});
      } else {
        axios
          .get(
            `https://api.wlffinance.org/api/user/mining/bitcoin/filter/view?page=${pageNumber}&filter=${filter}`,
            config
          )
          .then((response) => {
            setData(response?.data?.data);
            setPaginateData(response?.data);
          })
          .catch((error) => {});
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Handle submit form

  const refSubmitDis = useRef();
  const [miningInputData, setMiningInputData] = useState([]);
  const [findMiningId, setFindMiningId] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const navigate = useNavigate();

  const handleSubmitData = async (event) => {
    event.preventDefault();
    refSubmitDis.current.setAttribute("disabled", true);
    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };

      await axios
        .post(
          `https://api.wlffinance.org/api/user/mining/store/${findMiningId}`,
          { ...miningInputData, user_id: authUser?._id },
          config
        )
        .then((data) => {
          if (data?.data?.success) {
            Swal.fire({
              title: `${data.data.message}`,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            }).then((result) => {
              if (result.isConfirmed) {
                navigate("/user/dashboard");
              }
            });
            setUpdateData(data);
          }
          refSubmitDis.current.removeAttribute("disabled");
          event.target.reset();
        })
        .catch((error) => {
          setErrorMessage(error?.response?.data);
          toast.error(`${error?.response?.data?.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          refSubmitDis.current.removeAttribute("disabled");
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleMiningInputBlur = (event) => {
    const value = event.target.value;
    const field = event.target.name;
    const newUser = { ...miningInputData };
    newUser[field] = value;
    setMiningInputData(newUser);
  };

  const [messageData, setMessageData] = useState([]);

  useEffect(() => {
    fetch(`https://api.wlffinance.org/api/user/mining/bitcoin/message/view`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setMessageData(data?.data);
      });
  }, []);

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  } else {
    return (
      <>
        <section>
          <div className="container-custom">
            <div className="py-4">
              <div className=" user-deposit-title py-3 justify-content-center">
                <h1>Bitcoin Mining</h1>
              </div>
              {messageData?.title && (
                <div className="deposit-warning mb-3">
                  <small>
                    {(messageData?.title).slice(0, 80)}{" "}
                    {(messageData?.title).length >= 80 && "....."}
                  </small>
                  <br />
                  <Link
                    className="message-read-more-href"
                    to="/user/bitcoin/mining/message"
                    aria-expanded="false"
                    aria-controls="collapseSummary"
                  >
                    + Read More
                  </Link>
                </div>
              )}

              <div className="order-filter-area">
                <p>
                  <FontAwesomeIcon icon="fa-solid fa-filter" /> Filter
                </p>

                <div className="form-group">
                  <select className="form-select" onChange={handlePage}>
                    <option selected value="createdAt">
                      Newest
                    </option>
                    <option value="-createdAt">Older </option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div class="mining-area">
                  <div class="row gy-5">
                    {data?.length !== 0 ? (
                      data.map((data, index) => {
                        if (data) {
                          return (
                            <SingleItem
                              data={data}
                              index={index}
                              key={data._id}
                              handleSubmitData={handleSubmitData}
                              handleMiningInputBlur={handleMiningInputBlur}
                              setFindMiningId={setFindMiningId}
                              refSubmitDis={refSubmitDis}
                            ></SingleItem>
                          );
                        }
                      })
                    ) : (
                      <>
                        <div className="text-center h-50">
                          <h6> Data not found</h6>
                        </div>
                      </>
                    )}
                  </div>
                  {/* paginateLinks */}
                  <CustomPaginationMobile
                    data={paginateData}
                    handlePage={handlePage}
                  ></CustomPaginationMobile>
                  {/* paginateLinks */}
                </div>
              </div>
            </div>
          </div>
          <MobileBitcoinMiningHistory updateData={updateData} />
        </section>
      </>
    );
  }
};

export default MobileBitcoinMining;
